import React, { useState } from "react";
import { Mail, MapPin, Clock, MessageCircle, CalendarHeart, Briefcase } from "lucide-react";
import { IMAGES } from "../data/content";
import { Reveal } from "../components/Primitives";
import { ContactForm, ConsultationForm, ServiceRequestForm } from "../components/Forms";

const TABS = [
  { key: "contact", label: "Message", icon: MessageCircle },
  { key: "consultation", label: "Book a Consult", icon: CalendarHeart },
  { key: "service", label: "Service Request", icon: Briefcase },
];

export default function Contact() {
  const [tab, setTab] = useState("contact");

  return (
    <div data-testid="contact-page">
      <section className="pt-36 pb-12 md:pt-44 md:pb-16 bg-[#120726] grain text-center">
        <div className="container-loft max-w-3xl mx-auto">
          <Reveal>
            <p className="overline mb-5">Let's Connect</p>
            <h1 className="font-serif text-5xl md:text-7xl font-light leading-[1.03] text-[#2A2A2A]">
              Begin your <span className="text-gradient">journey</span>
            </h1>
            <p className="mt-7 text-lg md:text-xl font-light leading-relaxed text-[#2A2A2A]/75">
              Reach out, book a consultation, or request a service. Whatever brings you here,
              you are warmly welcome.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="pb-28 bg-[#1a0d33] pt-10">
        <div className="container-loft grid lg:grid-cols-12 gap-12 items-start">
          {/* LEFT: info + imagery */}
          <Reveal className="lg:col-span-4">
            <div className="relative grain rounded-[2rem] overflow-hidden mb-8">
              <div className="glow-ice absolute inset-0" />
              <img src={IMAGES.lotus} alt="Lotus" className="relative z-10 w-full h-72 object-cover" />
            </div>
            <div className="space-y-6">
              {[
                { icon: Mail, label: "Email", value: "hello@londonsloftoflyfe.com" },
                { icon: MapPin, label: "The Loft", value: "By appointment · In-person & virtual" },
                { icon: Clock, label: "Response time", value: "Within 1–2 business days" },
              ].map((info) => (
                <div key={info.label} className="flex items-start gap-4">
                  <div className="h-11 w-11 rounded-full bg-[#5B2C83]/10 grid place-items-center shrink-0">
                    <info.icon size={18} className="text-[#5B2C83]" />
                  </div>
                  <div>
                    <p className="overline text-[#4FD6AD]">{info.label}</p>
                    <p className="text-[#2A2A2A]/80 mt-1">{info.value}</p>
                  </div>
                </div>
              ))}
            </div>
          </Reveal>

          {/* RIGHT: forms */}
          <Reveal delay={0.12} className="lg:col-span-7 lg:col-start-6">
            <div className="flex flex-wrap gap-3 mb-8">
              {TABS.map((t) => (
                <button
                  key={t.key}
                  onClick={() => setTab(t.key)}
                  data-testid={`contact-tab-${t.key}`}
                  className={`inline-flex items-center gap-2 px-5 py-3 rounded-full text-sm transition-all duration-300 border ${
                    tab === t.key
                      ? "bg-[#5B2C83] text-white border-[#5B2C83] shadow-[0_10px_30px_rgba(91,44,131,0.22)]"
                      : "bg-white/5 text-[#2A2A2A]/70 border-[#C0C0C0]/40 hover:border-[#5B2C83]"
                  }`}
                >
                  <t.icon size={16} /> {t.label}
                </button>
              ))}
            </div>

            <div className="card-soft p-8 md:p-10">
              {tab === "contact" && <ContactForm />}
              {tab === "consultation" && <ConsultationForm />}
              {tab === "service" && <ServiceRequestForm />}
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
